import { render } from "./splashvideo.vue?vue&type=template&id=dc25f4f0"
import script from "./splashvideo.vue?vue&type=script&lang=js"
export * from "./splashvideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__